/**
 * @author PoornaChandu
 * @description This Component is mainly for Creating Jobplans and Task
 * @View Table with crud operations of Jobplanes
 */
import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import { Form, message, Col, Select, Tabs, Input, Modal, Button } from 'antd';
import { SearchOutlined, DownOutlined } from '@ant-design/icons';
import { decode as base64_decode } from 'base-64';

import TableSelect from '../../../Widgets/TableSelect';
import localStorage from '../../../../../utils/localStorage';
import {
  getSitesList,
  submitTask,
  getStatusListTask,
  getTaskById,
  getSkillTypeList
} from '../../../Utils/FormCalls';
import Highlighter from 'react-highlight-words';
import {
  StyledBox,
  StyledComponent
} from '../../../CSS/style';
import { constant } from '../../../Utils/constants';
import FileBase64 from '../../../Utils/FileUpload';
import translation from '../../../../../commons/translation';
import {
  ItemForm,
  ToolsForm,
  LaborForm,
  MaterialForm,
  FieldDataType,
  ObservationType
} from './TaskRequirements';
import InputComponent from '../../../Widgets/InputComponent';
import {
  API_DEVICE
} from '../../../../../commons/api';
import { useNavigate } from 'react-router-dom';

const { Option } = Select;
const { TabPane } = Tabs;
const fileData = new FormData();

const TaskForm = (props) => {
  // const [deviceList, setDeviceList] = useState([]);
  const [searchText, setSearchText] = useState('');
  const [sitesList, setSitesList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [visible, setVisible] = useState(false);
  const [tableData, setTableData] = useState([]);
  // const [dropdownSelection, setDropdownSelection] = useState({ deviceId: '' });
  const [SkillTypeList, setSkillTypeList] = useState([]);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const [formObject, setFormObject] = useState({});
  // const [hierarchyList, setHierarchyList] = useState([]);
  const formHeader = useRef(null);
  const searchInput = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchData();
  }, []);
  const fetchData = async () => {
    await _getDataById();
    // try {
    //   const hierarchyList = await getHierarchyList();
    //   setHierarchyList(hierarchyList);
    // } catch (error) {
    //   message.warn(`${error.message}`);
    // }
    try {
      const sitesList = await getSitesList();
      let formObject = formHeader.current ? formHeader.current.getFieldsValue() : {};
      formObject = {
        ...formObject,
        SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
      };
      if (formHeader.current) formHeader.current.setFieldsValue(formObject);
      setSitesList(sitesList);
      // setFormObject(formObject);
    } catch (error) {
      message.warn(`${error.message}`);
    }
    const SkillTypeList = await getSkillTypeList();
    setSkillTypeList(SkillTypeList);
    try {
      const statusList = await getStatusListTask();
      setStatusList(statusList);
    } catch (error) {
      message.warn(`${error.message}`);
    }
    // try {
    //   const usersList = await getUsersList();
    //   setUsersList(usersList);
    // } catch (error) {
    //   message.warn(`${error.message}`);
    // }
    // try {
    //   const uomList = await _getUOMList();
    //   setUomList(uomList);
    // } catch (error) {
    //   message.warn(`${error.message}`);
    // }
  };
  // useEffect(() => {
  //   if (props.history.location) {
  //     // onReset();
  //     // _getDataById();
  //   }
  // });
  useEffect(() => {
    setTranslationCache(props.translationCache);
  }, [props.translationCache]);

  const _getDataById = async (TaskId) => {
    let path = props.location.pathname.split('/rubus/AMM/TasksDetails/');
    let formId = TaskId ? TaskId : base64_decode(path[1]);
    if (formId !== 'new') {
      let formObject = await getTaskById(formId, 'withId');
      if (formObject && Array.isArray(formObject.ObservationType)) {
        formObject.ObservationType = formObject.ObservationType.map(item => ({
          ...item,
          EstimatedDuration: item.EstimatedDuration ? dayjs(item.EstimatedDuration) : undefined
        }));
      }
      setFormObject(formObject);
      if (formObject) {
        formHeader.current.setFieldsValue(formObject);
      }
    }
  };

  const handleSelect = (value, subindex, keyName, selectedObject) => {
    let data = formHeader.current.getFieldValue();
    if (keyName === 'Labor') {
      let skill = SkillTypeList.filter((item) => item.Id === selectedObject[0]['SkillTypeId']);
      if (data && data[keyName] && data[keyName][subindex]) {
        data[keyName][subindex]['SkillTypeName'] =
          skill && skill[0] && Array.isArray(skill) && skill[0].Type ? skill[0].Type : null;
        data[keyName][subindex]['Description'] = selectedObject[0]['Description'];
        data[keyName][subindex]['AvailableQuantity'] = selectedObject[0]['AvailableQuantity'];
      }
    } else {
      if (data && data[keyName] && data[keyName][subindex]) {
        data[keyName][subindex]['Description'] = selectedObject[0]['Description'];
        data[keyName][subindex]['AvailableQuantity'] = selectedObject[0]['AvailableQuantity'];
      }
    }
    formHeader.current.setFieldsValue(data);
    setFormObject(data);
  };
  const fileupload = async (values, key, fileDataObject) => {
    let file = fileDataObject;
    // let formObject = formHeader.current.getFieldsValue();
    if (formObject && formObject[key]) {
      formObject[key].push(...values);
    } else {
      formObject[key] = values;
    }
    // Removing duplicate file names
    formObject[key] = formObject[key].reduce((acc, current) => {
      const x = acc.find((item) => item.Name === current.Name);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    let FormObject = {
      ...formObject,
      [key]: formObject[key]
    };
    fileData.append('files', file);
    formHeader.current.setFieldsValue(FormObject);
    setFormObject(FormObject);

  };

  const onFinish = async (values) => {
    // const hasFieldData = Array.isArray(values.FieldDataType) && values.FieldDataType.length > 0;
    // const hasObservation = Array.isArray(values.ObservationType) && values.ObservationType.length > 0;
    const hasFieldData = values?.FieldDataType?.length > 0 || formObject?.FieldDataType?.length > 0;
    const hasObservation = values?.ObservationType?.length > 0 || formObject?.ObservationType?.length > 0;
    if (!hasFieldData && !hasObservation) { return; }
    let payload = {
      ...formObject,
      ...values,
      TaskStatusId: values.TaskStatusId,
      ObservationType: Array.isArray(values.ObservationType)
        ? values.ObservationType.map(item => ({
          ...item,
          EstimatedDuration: item?.EstimatedDuration
            ? dayjs(item.EstimatedDuration).format('YYYY-MM-DD HH:mm:ss')
            : undefined
        }))
        : []
    };
    let statusResponse = await submitTask(payload, fileData);
    if (statusResponse && statusResponse.message) {
      message.success('Task submitted successfully').then(() => {
        navigate('/rubus/AMM/Tasks');
      });
      _getDataById(statusResponse.Id);
    } else if (statusResponse && statusResponse.Error) {
      message.error(statusResponse.Error);
    } else {
      // message.warning('Please Add Sub Task');
    }
  };

  // const onReset = () => {
  //   formHeader.current && formHeader.current.resetFields();
  // };
  // const handleDropdownChange = (value) => {
  //   let Dropdownselection = {
  //     ...dropdownSelection,
  //     ...value
  //   }
  //   setDropdownSelection(Dropdownselection);
  // };
  // const hierarchyDropdownChange = (value) => {
  //   let formObject = formHeader.current.getFieldsValue();
  //   formObject = {
  //     ...formObject,
  //     Hierarachym: value.ShortDescription,
  //     Location: value.LongDescription
  //   };
  //   formHeader.current.setFieldsValue(formObject);
  //   setVisible(false);
  // };
  // const handleCancel = () => {
  //   setVisible(false);
  // };
  // const getHierarchyLevels = () => {
  //   const siteId = localStorage.get('currentSite');
  //   const accessToken = localStorage.get('accessToken');
  //   let headers = {
  //     method: 'GET',
  //     url: `${API_HIERARCHYMODULE.GetHierarchyLevels}?SiteId=${siteId}&HierarchyCode=${hierarchyList[0]?.HierarchyCode}&Type=Device`,
  //     headers: {
  //       Authorization: `Bearer ${accessToken}`
  //     }
  //   };
  //   axios(headers)
  //     .then(({ data }) => {
  //       if (Array.isArray(data)) {
  //         setTableData(data);
  //         setVisible(true);
  //         setFormObject(formHeader.current.getFieldsValue());
  //       }
  //     })
  //     .catch((error) => {
  //       message.error(error);
  //     });
  // };
  // const hierarchyDropdownChange = (value) => {
  //   let formObject = this.formHeader.current.getFieldsValue();
  //   formObject = {
  //     ...formObject,
  //     Equipment: value.Code,
  //     EquipmentDescription: value.Name
  //   };
  //   this.formHeader.current.setFieldsValue(formObject);
  //   this.setState({
  //     visible: false,
  //     formObject
  //   });
  // };
  const onDrawerCancel = () => {
    setVisible(false);
  };

  // const getValueFromList = (list, compareKey, compareValue, resultKey) => {
  //   let filterObject = [];
  //   if (list && Array.isArray(list)) {
  //     filterObject = list.filter((listObject) => listObject[compareKey] === compareValue);
  //   }
  //   return filterObject && filterObject[0] && filterObject[0][resultKey]
  //     ? filterObject[0][resultKey]
  //     : '';
  // };
  // const onTaskSelection = (val) => {
  //   if (val === 'observationType') {
  //     setViewObservationType(true);
  //     setViewfieldDataType(false);
  //   } else {
  //     setViewfieldDataType(true);
  //     setViewObservationType(false);
  //   }
  // };
  // const ObservationCancel = () => {
  //   setViewObservationType(false);
  // };
  // const ObservationoK = () => {
  //   setViewObservationType(false);
  // };
  // const datepickerchange = (date, dateString, key) => {
  //   let formObject = formHeader.current.getFieldsValue();
  //   let EstimatedDuration = null;
  //   if (
  //     key &&
  //     key === 'EndTime' &&
  //     formHeader.current.getFieldValue() &&
  //     formHeader.current.getFieldValue()['StartTime']
  //   ) {
  //     let startTime = formHeader.current.getFieldValue()['StartTime'];
  //     let endTime = date;
  //     let ms = dayjs(endTime, 'YYYY-MM-DD HH:mm').diff(moment(startTime, 'YYYY-MM-DD HH:mm'));
  //     let d = moment.duration(ms);
  //     EstimatedDuration = Math.floor(d.asHours()) + moment.utc(ms).format(':mm:ss');
  //   } else if (
  //     key &&
  //     key === 'StartTime' &&
  //     formHeader.current.getFieldValue() &&
  //     formHeader.current.getFieldValue()['EndTime']
  //   ) {
  //     let endTime = formHeader.current.getFieldValue()['EndTime'];
  //     let startTime = date;
  //     let ms = moment(endTime, 'YYYY-MM-DD HH:mm').diff(moment(startTime, 'YYYY-MM-DD HH:mm'));
  //     let d = moment.duration(ms);
  //     EstimatedDuration = Math.floor(d.asHours()) + moment.utc(ms).format(':mm:ss');
  //   }
  //   formObject['EstimatedDuration'] = EstimatedDuration;
  //   formHeader.current.setFieldsValue(formObject);
  // };
  // const getDisabledHours = (e, key) => {
  //   let hours = [];
  //   let minutes = [];
  //   let StartDateTime = '';
  //   let EndDateTime = '';
  //   let StartDate = '';
  //   let EndDate = '';
  //   if (key === 'StartTime') {
  //     StartDateTime = moment(e).format('YYYY-MM-DD HH:mm');
  //     EndDateTime = moment
  //       .utc(formHeader.current.getFieldValue()['EndTime'], 'YYYY-MM-DD HH:mm')
  //       .local();
  //     StartDate = moment(e).format('YYYY-MM-DD');
  //     EndDate = moment
  //       .utc(formHeader.current.getFieldValue()['EndTime'])
  //       .local()
  //       .format('YYYY-MM-DD');
  //   } else if (key === 'EndTime') {
  //     StartDateTime = moment
  //       .utc(formHeader.current.getFieldValue()['StartTime'], 'YYYY-MM-DD HH:mm')
  //       .local();
  //     EndDateTime = moment(e).format('YYYY-MM-DD HH:mm');
  //     StartDate = moment
  //       .utc(formHeader.current.getFieldValue()['StartTime'])
  //       .local()
  //       .format('YYYY-MM-DD');
  //     EndDate = moment(e).format('YYYY-MM-DD');
  //   }
  //   if (
  //     key === 'StartTime' &&
  //     moment(StartDate).isSame(moment(EndDate) || moment(StartDateTime).hours() === moment(EndDateTime).hours())
  //   ) {
  //     for (var i = 0; i <= 24; i++) {
  //       if (i > moment(EndDateTime).hours()) {
  //         hours.push(i);
  //       }
  //     }
  //     if (moment(StartDate).isSame(moment(EndDate))) {
  //       for (var j = 0; j <= 60; j++) {
  //         if (j > moment(EndDateTime).minutes() - 1) {
  //           minutes.push(j);
  //         }
  //       }
  //     }
  //     return {
  //       disabledHours: () => hours,
  //       disabledMinutes: () => minutes
  //     };
  //   } else if (
  //     key === 'EndTime' &&
  //     moment(StartDate).isSame(moment(EndDate) || moment(StartDateTime).hours() === moment(EndDateTime).hours())
  //   ) {
  //     for (var k = 0; k < moment(StartDateTime).hours(); k++) {
  //       if (k < 25) {
  //         hours.push(k);
  //       }
  //     }
  //     if (moment(StartDate).isSame(moment(EndDate))) {
  //       for (var J = 0; J < moment(StartDateTime).minutes() + 1; J++) {
  //         if (J < 61) {
  //           minutes.push(J);
  //         }
  //       }
  //     }
  //     return {
  //       disabledHours: () => hours,
  //       disabledMinutes: () => minutes
  //     };
  //   }
  // };
  // {viewObservationType === true ? (
  //   <>
  //     <StyledSubHeading theme={themeSettings} style={{ marginLeft: '40%' }}>
  //       {translation(translationCache, 'Observation Type Details')}
  //     </StyledSubHeading>
  //     <div style={{ display: 'flex', flexWrap: 'wrap' }}>
  //       <Form.Item
  //         style={{ width: '100%', flex: '50%' }}
  //         label={translation(translationCache, constant.taskItem)}
  //         name="Name"
  //         rules={[{ required: true }]}
  //       >
  //         <InputComponent
  //           placeholder={translation(translationCache, 'Enter Name')}
  //           value={formObject.Name}
  //           style={{ width: '70%' }}
  //           //maxLength={30}
  //         />
  //       </Form.Item>
  //       <Form.Item
  //         style={{ width: '100%', flex: '50%' }}
  //         label={translation(translationCache, constant.taskDescription)}
  //         name="Description"
  //         rules={[{ required: true }]}
  //       >
  //         <InputComponent
  //           placeholder={translation(translationCache, 'Enter Description')}
  //           value={formObject.Description}
  //           style={{ width: '70%' }}
  //           //maxLength={150}
  //         />
  //       </Form.Item>
  //       <Form.Item
  //         style={{ width: '100%', flex: '50%' }}
  //         label={translation(translationCache, constant.criterion)}
  //         name="Criteria"
  //         rules={[{ required: false }]}
  //       >
  //         <InputComponent
  //           placeholder={translation(translationCache, 'Enter Criteria')}
  //           value={formObject.Criteria}
  //           style={{ width: '70%' }}
  //           //maxLength={30}
  //         />
  //       </Form.Item>
  //       <Form.Item
  //         style={{ width: '100%', flex: '50%' }}
  //         label={translation(translationCache, constant.method)}
  //         name="Method"
  //         rules={[{ required: false }]}
  //       >
  //         <InputComponent
  //           placeholder={translation(translationCache, 'Enter Method')}
  //           value={formObject.Method}
  //           style={{ width: '70%' }}
  //           //maxLength={30}
  //         />
  //       </Form.Item>
  //       <Form.Item
  //         style={{ width: '100%', flex: '50%' }}
  //         label={translation(translationCache, constant.observation)}
  //         name="Observation"
  //         rules={[{ required: false }]}
  //       >
  //         <InputComponent
  //           placeholder={translation(translationCache, 'Enter Observation')}
  //           value={formObject.Observation}
  //           style={{ width: '70%' }}
  //           //maxLength={30}
  //         />
  //       </Form.Item>
  //       <Form.Item
  //         style={{ width: '100%', flex: '50%' }}
  //         label={translation(translationCache, constant.estimatedDuration)}
  //         name="EstimatedDuration"
  //       >
  //         <TimePicker
  //           style={{ width: '70%' }}
  //           format={'HH:mm'}
  //           allowClear={false}
  //           onChange={(value) => handleChange(value, 'EstimatedDuration')}
  //         />
  //         {/* <InputComponent
  //             disabled
  //             placeholder={translation(translationCache,"Autopopulate EstimatedDuration  Basis To The Start & End Time"
  //             style={{ width: '70%' }}
  //             //maxLength={10}
  //           /> */}
  //       </Form.Item>
  //       {/* <Form.Item
  //           style={{ width: '100%', flex: '50%' }}
  //           label={translation(translationCache, constant.startTime)}
  //           name="StartTime"
  //           rules={[{ required: false }]}
  //         >
  //           <DatePicker
  //             // inputReadOnly={true}
  //             style={{ width: '70%' }}
  //             format="YYYY-MM-DD HH:mm:ss"
  //             // inputReadOnly={false}
  //             placeholder={translation(translationCache,"Select Start Date Time")}
  //             value={moment().format('YYYY-MM-DD HH:mm:ss')}
  //             // disabledDate={disabledDate}
  //             onChange={(date, dateString) => {
  //               datepickerchange(date, dateString, 'StartTime');
  //             }}
  //             showTime={{
  //               defaultValue: moment('00:00:00', 'HH:mm:ss')
  //             }}
  //             disabledDate={(d) =>
  //               //     formHeader.current.getFieldValue("EndTime")
  //               //                 ? moment(formHeader.current.getFieldValue("EndTime")).add(1, "day").format("YYYY-MM-DD") : ""
  //               //         ))
  //               !d ||
  //               d.isAfter(
  //                 formHeader.current.getFieldValue() &&
  //                   formHeader.current.getFieldValue()['EndTime']
  //                   ? moment(formHeader.current.getFieldValue()['EndTime'])
  //                       .add(1, 'day')
  //                       .format('YYYY-MM-DD')
  //                   : ''
  //               ) ||
  //               d.isBefore(moment().format('YYYY-MM-DD'))
  //             }
  //             disabledTime={(e) =>
  //               getDisabledHours(moment(e, 'YYYY-MM-DD HH:mm:ss'), 'StartTime')
  //             }
  //           />
  //         </Form.Item>
  //         <Form.Item
  //           style={{ width: '100%', flex: '50%' }}
  //           label={translation(translationCache, constant.endTime)}
  //           name="EndTime"
  //           rules={[{ required: false }]}
  //         >
  //           <DatePicker
  //             inputReadOnly={true}
  //             style={{ width: '70%' }}
  //             placeholder={translation(translationCache,"Select End Date Time")}
  //             format="YYYY-MM-DD HH:mm:ss"
  //             value={moment().format('YYYY-MM-DD HH:mm:ss')}
  //             onChange={(date, dateString) => {
  //               datepickerchange(date, dateString, 'EndTime');
  //             }}
  //             // inputReadOnly={false}
  //             disabledDate={(d) =>
  //               //     formHeader.current.getFieldValue("EndTime")
  //               //                 ? moment(formHeader.current.getFieldValue("EndTime")).add(1, "day").format("YYYY-MM-DD") : ""
  //               //         ))
  //               !d ||
  //               d.isBefore(
  //                 formHeader.current &&
  //                   formHeader.current !== null &&
  //                   formHeader.current.getFieldValue() &&
  //                   formHeader.current.getFieldValue()['StartTime']
  //                   ? moment(
  //                       formHeader.current.getFieldValue() &&
  //                         formHeader.current.getFieldValue()['StartTime']
  //                     ).format('YYYY-MM-DD')
  //                   : ''
  //               ) ||
  //               d.isBefore(moment().format('YYYY-MM-DD'))
  //             }
  //             disabledTime={(e) =>
  //               getDisabledHours(moment(e, 'YYYY-MM-DD HH:mm:ss'), 'EndTime')
  //             }
  //             showTime={{
  //               defaultValue: moment('00:00:00', 'HH:mm:ss')
  //             }}
  //           />
  //         </Form.Item> */}
  //       <Form.Item
  //         style={{ width: '100%', flex: '50%' }}
  //         label={translation(translationCache, constant.remarks)}
  //         name="Remarks"
  //         rules={[{ required: false }]}
  //       >
  //         <TextArea
  //           rows={4}
  //           placeholder={translation(translationCache, 'Enter Remarks')}
  //           value={formObject.Remarks}
  //           style={{ width: '70%', hieght: '70%' }}
  //           //maxLength={100}
  //         />
  //       </Form.Item>
  //       {/* <Form.Item
  //           style={{ width: '100%', flex: '50%' }}
  //           label={translation(translationCache, constant.UOM)}
  //           name="UOM"
  //           rules={[{ required: false }]}
  //         >
  //           <Select placeholder={translation(translationCache,"Select UOM")} style={{ width: '70%' }}>
  //             {uomList.map((uom, index) => {
  //               return (
  //                 <Option key={index} value={uom.Key}>
  //                   {' '}
  //                   {uom.Key}{' '}
  //                 </Option>
  //               );
  //             })}
  //           </Select>
  //         </Form.Item> */}
  //       <Form.Item
  //         label={translation(translationCache, constant.attachments)}
  //         name="Attachments"
  //         style={{ width: '100%', flex: '50%' }}
  //       >
  //         <FileBase64
  //           style={{ width: '70%' }}
  //           downloadClassName={'formdownloadInput'}
  //           Attachments={formObject.Attachments}
  //           fileUpload={fileupload}
  //         ></FileBase64>
  //       </Form.Item>
  //       <Form.Item style={{ width: '100%', flex: '50%' }} name="test">
  //         <InputComponent
  //           //maxLength={20}
  //           style={{ display: 'none' }}
  //         />
  //       </Form.Item>
  //       <Form.Item name="Equipment"></Form.Item>
  //     </div>
  //   </>
  // ) : (
  //   ''
  // )}
  // {viewfieldDataType === true ? (
  //   <>
  //     <StyledSubHeading theme={themeSettings} style={{ marginLeft: '40%' }}>
  //       {translation(translationCache, 'FieldData Type Details')}
  //     </StyledSubHeading>
  //     <div style={{ display: 'flex', flexWrap: 'wrap' }}>
  //       <Form.Item
  //         style={{ width: '100%', flex: '50%' }}
  //         label={translation(translationCache, constant.taskItem)}
  //         name="Name"
  //         rules={[{ required: true }]}
  //       >
  //         <InputComponent
  //           placeholder={translation(translationCache, 'Enter Task')}
  //           value={formObject.Task}
  //           style={{ width: '70%' }}
  //           //maxLength={30}
  //         />
  //       </Form.Item>
  //       <Form.Item
  //         style={{ width: '100%', flex: '50%' }}
  //         label={translation(translationCache, constant.taskDescription)}
  //         name="Description"
  //         rules={[{ required: true }]}
  //       >
  //         <InputComponent
  //           placeholder={translation(translationCache, 'Enter Description')}
  //           value={formObject.Description}
  //           style={{ width: '70%' }}
  //           //maxLength={100}
  //         />
  //       </Form.Item>
  //       {/* <Form.Item
  //           style={{ width: '100%', flex: '50%' }}
  //           label={translation(translationCache, constant.measurementDate)}
  //           name="MeasurementDate"
  //           rules={[{ required: false }]}
  //         >
  //           <DatePicker
  //             style={{ width: '70%' }}
  //             disabledDate={(d) => d.isBefore(moment().format('YYYY-MM-DD'))}
  //             placeholder={translation(translationCache,"Select Actual End Date Time")}
  //             format="YYYY-MM-DD"
  //           />
  //         </Form.Item> */}
  //       <Form.Item
  //         style={{ width: '100%', flex: '50%' }}
  //         label={translation(translationCache, constant.measurementValue)}
  //         name="MeasurementValue"
  //         rules={[
  //           {
  //             // pattern: new RegExp(/^[0-9]*$/)
  //             // message: 'field accept only postive values'
  //           }
  //         ]}
  //       >
  //         <InputComponent
  //           placeholder={translation(translationCache, 'Enter Measurement Value')}
  //           value={formObject.MeasurementValue}
  //           style={{ width: '70%' }}
  //           //maxLength={30}
  //         />
  //       </Form.Item>
  //       <Form.Item
  //         style={{ width: '100%', flex: '50%' }}
  //         label={translation(translationCache, constant.UOM)}
  //         name="UOM"
  //         rules={[{ required: false }]}
  //       >
  //         <Select
  //           placeholder={translation(translationCache, 'Select UOM')}
  //           style={{ width: '70%' }}
  //         >
  //           {uomList.map((uom, index) => {
  //             return (
  //               <Option key={index} value={uom.UOM}>
  //                 {' '}
  //                 {uom.UOM}{' '}
  //               </Option>
  //             );
  //           })}
  //         </Select>
  //       </Form.Item>
  //       <Form.Item
  //         style={{ width: '100%', flex: '50%' }}
  //         label={translation(translationCache, constant.inspectionMethod)}
  //         name="Method"
  //         rules={[{ required: false }]}
  //       >
  //         <InputComponent
  //           placeholder={translation(translationCache, 'Enter Inspection Method')}
  //           value={formObject.InspectionMethod}
  //           style={{ width: '70%' }}
  //           //maxLength={30}
  //         />
  //       </Form.Item>
  //       <Form.Item
  //         style={{ width: '100%', flex: '50%' }}
  //         label={translation(translationCache, constant.criterion)}
  //         name="Criteria"
  //         rules={[{ required: false }]}
  //       >
  //         <InputComponent
  //           placeholder={translation(translationCache, 'Enter Criteria')}
  //           value={formObject.Criteria}
  //           style={{ width: '70%' }}
  //           //maxLength={30}
  //         />
  //       </Form.Item>
  //       <Form.Item
  //         style={{ width: '100%', flex: '50%' }}
  //         label={translation(translationCache, constant.observation)}
  //         name="Observation"
  //         rules={[{ required: false }]}
  //       >
  //         <InputComponent
  //           placeholder={translation(translationCache, 'Enter Observation')}
  //           value={formObject.Observation}
  //           style={{ width: '70%' }}
  //           //maxLength={30}
  //         />
  //       </Form.Item>
  //       {/* <Form.Item
  //           style={{ width: '100%', flex: '50%' }}
  //           label={translation(translationCache, constant.estimatedDuration)}
  //           name="EstimatedDuration"
  //         >
  //           <InputComponent
  //             disabled
  //             placeholder={translation(translationCache,"Autopopulate EstimatedDuration  Basis To The Start & End Time")}
  //             style={{ width: '70%' }}
  //             //maxLength={10}
  //           />
  //         </Form.Item> */}
  //       <Form.Item
  //         label={translation(translationCache, constant.attachments)}
  //         name="Attachments"
  //         style={{ width: '100%', flex: '50%' }}
  //       >
  //         <FileBase64
  //           style={{ width: '70%' }}
  //           downloadClassName={'formdownloadInput'}
  //           Attachments={formObject.Attachments}
  //           fileUpload={fileupload}
  //         ></FileBase64>
  //       </Form.Item>
  //       <Form.Item
  //         style={{ width: '100%', flex: '50%' }}
  //         label={translation(translationCache, constant.recordedBy)}
  //         name="RecordBy"
  //         rules={[{ required: false }]}
  //       >
  //         <Select
  //           placeholder={translation(translationCache, 'Select RecordedBy')}
  //           style={{ width: '70%' }}
  //         >
  //           {usersList &&
  //             Array.isArray(usersList) &&
  //             usersList.length > 0 &&
  //             usersList.map((item, index) => {
  //               return (
  //                 <Option key={index} value={item.Id}>
  //                   {' '}
  //                   {item.FirstName}{' '}
  //                 </Option>
  //               );
  //             })}
  //         </Select>
  //       </Form.Item>
  //       {/* <Form.Item
  //           style={{ width: '100%', flex: '50%' }}
  //           label={translation(translationCache, constant.actualStartTime)}
  //           name="StartTime"
  //           rules={[{ required: false }]}
  //         >
  //           <DatePicker
  //             inputReadOnly={true}
  //             style={{ width: '70%' }}
  //             format="YYYY-MM-DD HH:mm:ss"
  //             // inputReadOnly={false}
  //             placeholder={translation(translationCache,"Select Actual Start Date Time")}
  //             onChange={(date, dateString) => {
  //               datepickerchange(date, dateString, 'StartTime');
  //             }}
  //             showTime={{
  //               defaultValue: moment('00:00:00', 'HH:mm:ss')
  //             }}
  //             disabledDate={(d) =>
  //               //     formHeader.current.getFieldValue("EndTime")
  //               //                 ? moment(formHeader.current.getFieldValue("EndTime")).add(1, "day").format("YYYY-MM-DD") : ""
  //               //         ))
  //               !d ||
  //               d.isAfter(
  //                 formHeader.current.getFieldValue() &&
  //                   formHeader.current.getFieldValue()['EndTime']
  //                   ? moment(formHeader.current.getFieldValue()['EndTime'])
  //                     .add(1, 'day')
  //                     .format('YYYY-MM-DD')
  //                   : ''
  //               ) ||
  //               d.isBefore(moment().format('YYYY-MM-DD'))
  //             }
  //             disabledTime={(e) =>
  //               getDisabledHours(moment(e, 'YYYY-MM-DD HH:mm:ss'), 'StartTime')
  //             }
  //           />
  //         </Form.Item>
  //         <Form.Item
  //           style={{ width: '100%', flex: '50%' }}
  //           label={translation(translationCache, constant.actualEndTime)}
  //           name="EndTime"
  //           rules={[{ required: false }]}
  //         >
  //           <DatePicker
  //             inputReadOnly={true}
  //             style={{ width: '70%' }}
  //             placeholder={translation(translationCache,"Select Actual End Date Time")}
  //             format="YYYY-MM-DD HH:mm:ss"
  //             onChange={(date, dateString) => {
  //               datepickerchange(date, dateString, 'EndTime');
  //             }}
  //             // inputReadOnly={false}
  //             disabledDate={(d) =>
  //               //     formHeader.current.getFieldValue("EndTime")
  //               //                 ? moment(formHeader.current.getFieldValue("EndTime")).add(1, "day").format("YYYY-MM-DD") : ""
  //               //         ))
  //               !d ||
  //               d.isBefore(
  //                 formHeader.current &&
  //                   formHeader.current !== null &&
  //                   formHeader.current.getFieldValue() &&
  //                   formHeader.current.getFieldValue()['StartTime']
  //                   ? moment(
  //                     formHeader.current.getFieldValue() &&
  //                     formHeader.current.getFieldValue()['StartTime']
  //                   ).format('YYYY-MM-DD')
  //                   : ''
  //               ) ||
  //               d.isBefore(moment().format('YYYY-MM-DD'))
  //             }
  //             disabledTime={(e) =>
  //               getDisabledHours(moment(e, 'YYYY-MM-DD HH:mm:ss'), 'EndTime')
  //             }
  //             showTime={{
  //               defaultValue: moment('00:00:00', 'HH:mm:ss')
  //             }}
  //           />
  //         </Form.Item>
  //         <Form.Item
  //           style={{ width: '100%', flex: '50%' }}
  //           label={translation(translationCache, constant.observation)}
  //           name="Observation"
  //           rules={[{ required: false }]}
  //         >
  //           <InputComponent
  //             placeholder={translation(translationCache,"Enter Observation")}
  //             value={formObject.Observation}
  //             style={{ width: '70%' }}
  //             //maxLength={30}
  //           />
  //         </Form.Item> */}
  //       <Form.Item style={{ width: '100%', flex: '50%' }} name="test">
  //         <InputComponent
  //           //maxLength={20}
  //           style={{ display: 'none' }}
  //         />
  //       </Form.Item>
  //     </div>
  //   </>
  // ) : (
  //   ''
  // )}
  const getDeviceData = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `${API_DEVICE.LIST}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(({ data }) => {
        setTableData(data);
        setVisible(true);
        setFormObject(formHeader.current.getFieldsValue());
      })
      .catch(() => { });
  };
  const TableDropdownChange = (value) => {
    let formObject = formHeader.current.getFieldsValue();
    formObject = {
      ...formObject,
      Equipment: value.AliasCode,
      EquipmentDescription: value.Name,
      DeviceCode: value.DeviceCode,
      DisplayCode: value.DisplayCode
    };
    formHeader.current.setFieldsValue(formObject);
    setFormObject(formObject);
    setVisible(false);
  };
  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };
  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={translation(props.translationCache, `Search`)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(props.translationCache, `Search`)}
        </Button>
        <Button
          onClick={() => handleReset(clearFilters, confirm)}
          style={{ width: 90 }}
        >
          {translation(props.translationCache, `Reset`)}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });
  /* eslint-disable no-template-curly-in-string */
  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!'
    },
    number: {
      range: '${label} must be between ${min} and ${max}'
    }
    // pattern: {
    //   mismatch: '${label} does not match pattern'
    // }
  };
  const themeBackground = props && props.themeValue && props.themeValue.token && props.themeValue.token.colorBgBase;

  return (
    <>
      <StyledComponent
        // theme={themeSettings}
        style={{ padding: '0px 15px', minHeight: window.innerHeight - 143 }}
      >
        <Form
          name="TaskData"
          ref={formHeader}
          initialValues={formObject}
          onFinish={onFinish}
          layout="horizontal"
          labelCol={{ flex: '130px' }}
          labelAlign="right"
          labelWrap
          validateMessages={validateMessages}
        >

          <div style={{ display: 'flex', justifyContent: 'right' }}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                {translation(translationCache, constant.submit)}
              </Button>
            </Form.Item>
          </div>
          <StyledBox themeBackground={themeBackground} style={{ padding: "20px" }}>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <Form.Item
                label={translation(translationCache, constant.taskName)}
                name={'TaskName'}
                style={{
                  width: '100%',
                  flex: '50%'
                }}
                rules={[
                  { required: true }
                ]}
              >
                <InputComponent
                  placeholder={translation(translationCache, 'Enter Name')}
                  value={formObject && formObject.TaskName ? formObject.TaskName : ''}
                  style={{ width: '70%' }}
                  //maxLength={30}
                  disabled={formObject && formObject.Id ? true : false}
                />
              </Form.Item>
              <Form.Item
                label={translation(translationCache, constant.taskDescription)}
                name={'TaskDescription'}
                style={{ width: '100%', flex: '50%' }}
                rules={[{ required: true }]}
              >
                <InputComponent
                  placeholder={translation(translationCache, 'Enter Task Description')}
                  value={formObject && formObject.TaskDescription ? formObject.TaskDescription : ''}
                  style={{ width: '70%' }}
                //maxLength={150}
                />
              </Form.Item>
              <Form.Item name="Equipment"></Form.Item>
              <Form.Item
                label={translation(translationCache, constant.equipment)}
                name="DisplayCode"
                style={{
                  width: '100%',
                  flex: '50%'
                  // display: formObject && formObject.Id ? 'none' : true
                }}
                rules={[{ required: true }]}
              >
                <Input
                  style={{ width: '70%' }}
                  // value={formObject.Location}
                  placeholder={translation(translationCache, 'Select Equipment')}
                  disabled={true}
                  suffix={
                    <DownOutlined
                      style={{
                        // color: '#1a3b5c',
                        color: formObject && formObject.Id ? null : '#1a3b5c',
                        cursor: formObject && formObject.Id ? 'not-allowed' : null,
                        opacity: formObject && formObject.Id ? '0.8' : null
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        if (formObject && !formObject.Id) {
                          getDeviceData('visible');
                        }
                      }}
                    />
                  }
                />
                {/* <Select
                  value={formObject.Equipment}
                  placeholder={translation(translationCache,"Select Equipment")}
                  disabled={true}
                  style={{ width: '70%' }}
                  suffixIcon={
                    <ApartmentOutlined
                      className="apartmentOutlined"
                      style={{
                        color: '#1a3b5c',
                        opacity: formObject && formObject.Id ? 0.5 : null
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        getHierarchyLevels(hierarchyList);
                      }}
                      // style={{ color: 'red !important' }}
                    />
                  }
                /> */}
              </Form.Item>
              <Form.Item
                style={{
                  width: '100%',
                  flex: '50%'
                  // display: formObject && formObject.Id ? 'none' : true
                }}
                label={translation(translationCache, constant.equipmentDescription)}
                name="EquipmentDescription"
                rules={[{ required: true }]}
              >
                <InputComponent
                  disabled={true}
                  style={{ width: '70%' }}
                  placeholder={translation(translationCache, 'Autopopulate Basis To The Equipment')}
                //maxLength={150}
                />
              </Form.Item>
              <Form.Item
                label={translation(translationCache, constant.site)}
                name="SiteId"
                style={{
                  width: '100%',
                  flex: '50%'
                  // display: formObject && formObject.Id ? 'none' : true
                }}
                rules={[{ required: true }]}
              >
                <Select
                  placeholder={translation(translationCache, 'Select Site')}
                  style={{ width: '70%' }}
                  disabled={formObject && formObject.Id ? true : false}
                >
                  {sitesList &&
                    Array.isArray(sitesList) &&
                    sitesList.map((site, index) => {
                      return (
                        <Option key={index} value={site.Id}>
                          {' '}
                          {site.Name}{' '}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
              <Form.Item
                label={translation(translationCache, constant.status)}
                name="TaskStatusId"
                style={{ width: '100%', flex: '50%' }}
                rules={[{ required: true }]}
              >
                <Select
                  placeholder={translation(translationCache, 'Select Status')}
                  style={{ width: '70%' }}
                >
                  {statusList &&
                    Array.isArray(statusList) &&
                    statusList.map((status, index) => {
                      return (
                        <Option key={index} value={status.Value}>
                          {translation(translationCache, status.Key)}
                        </Option>
                      );
                    })}
                </Select>
              </Form.Item>
              {/* <Form.Item
                style={{ width: '100%', flex: '50%' }}
                label={translation(translationCache, constant.TaskType)}
                name="Type"
                rules={[{ required: true }]}
              >
                <Select
                  style={{ width: '70%' }}
                  placeholder={translation(translationCache, 'Select Task')}
                  multiple
                  // defaultValue={selectedTaskADD
                  disabled={formObject && formObject.Id ? true : false}
                  onChange={(value) => onTaskSelection(value)}
                  notFoundContent={'Please Select Equipment For Tasks'}
                >
                  <option value="observationType">
                    {translation(translationCache, constant.observationType)}
                  </option>
                  <option value="fieldDataType">
                    {translation(translationCache, constant.fieldDataType)}
                  </option>
                </Select>
              </Form.Item> */}
              <Form.Item
                label={translation(translationCache, constant.attachments)}
                name="Attachments"
                style={{ width: '100%', flex: '50%' }}
              >
                <FileBase64
                  style={{ width: '70%' }}
                  downloadClassName={'formdownloadInput'}
                  Attachments={formObject && formObject.Attachments}
                  fileUpload={fileupload}
                ></FileBase64>
              </Form.Item>
              <Form.Item style={{ width: '100%', flex: '50%' }} name="TaskName">
                <InputComponent
                  //maxLength={20}
                  style={{ display: 'none' }}
                />
              </Form.Item>

              <Form.Item name="Id"></Form.Item>
              <Form.Item name="Labor"></Form.Item>
              <Form.Item name="Materials"></Form.Item>
              <Form.Item name="Items"></Form.Item>
            </div>
          </StyledBox>
          <StyledBox themeBackground={themeBackground} style={{ padding: "0px 20px" }}>
            <Tabs>
              <TabPane tab={translation(translationCache, 'Tools')} key="1">
                <Form.Item name="Tools">
                  <ToolsForm
                    quantity={'4'}
                    formObject={
                      formHeader && formHeader.current && formHeader.current !== null
                        ? formHeader.current.getFieldsValue()
                        : {}
                    }
                    onToolChange={handleSelect}
                    formHeader={formHeader}
                  />
                </Form.Item>
              </TabPane>
              <TabPane tab={translation(translationCache, 'ManPower')} key="2">
                <Col span={24}>
                  <Form.Item name="Labor">
                    <LaborForm
                      quantity={'4'}
                      formObject={
                        formHeader && formHeader.current !== null
                          ? formHeader.current.getFieldsValue()
                          : {}
                      }
                      onLaborChange={handleSelect}
                      formHeader={formHeader}
                    />
                  </Form.Item>
                </Col>
              </TabPane>
              <TabPane tab={translation(translationCache, 'Material')} key="3">
                <Col span={24}>
                  <Form.Item name="Materials">
                    <MaterialForm
                      quantity={'4'}
                      formObject={
                        formHeader && formHeader.current && formHeader.current !== null
                          ? formHeader.current.getFieldsValue()
                          : {}
                      }
                      onMaterialChange={handleSelect}
                      formHeader={formHeader}
                    />
                  </Form.Item>
                </Col>
              </TabPane>
              <TabPane tab={translation(translationCache, 'Items')} key="4">
                <Col span={24}>
                  <Form.Item name="Items">
                    <ItemForm
                      quantity={'4'}
                      formObject={
                        formHeader && formHeader.current !== null
                          ? formHeader.current.getFieldsValue()
                          : {}
                      }
                      onItemChange={handleSelect}
                      formHeader={formHeader}
                    />
                  </Form.Item>
                </Col>
              </TabPane>
              <TabPane tab={translation(translationCache, 'Field Data Type')} key="5">
                <Col span={24}>
                  <Form.Item name="FieldDataType">
                    <FieldDataType
                      quantity={'4'}
                      formObject={
                        formHeader && formHeader.current !== null
                          ? formHeader.current.getFieldsValue()
                          : {}
                      }
                      onFieldChange={handleSelect}
                      formHeader={formHeader}
                    />
                  </Form.Item>
                </Col>
              </TabPane>
              <TabPane tab={translation(translationCache, 'Observation Type')} key="6">
                <Col span={24}>
                  <Form.Item name="Observation">
                    <ObservationType
                      quantity={'4'}
                      formObject={
                        formHeader && formHeader.current !== null
                          ? formHeader.current.getFieldsValue()
                          : {}
                      }
                      onObservationChange={handleSelect}
                      formHeader={formHeader}
                    />
                  </Form.Item>
                </Col>
              </TabPane>
            </Tabs>
          </StyledBox>
        </Form>
        <Modal
          open={visible}
          width={1000}
          closable
          title={translation(translationCache, constant.selectEquipment)}
          onCancel={onDrawerCancel}
          onOk={onDrawerCancel}
        >
          <TableSelect
            data={tableData}
            translationCache={props.translationCache}
            key="Equipment"
            columns={[
              {
                title: translation(translationCache, 'Equipment'),
                dataIndex: 'DisplayCode',
                key: 'DisplayCode',
                ...getColumnSearchProps('DisplayCode')
              },
              {
                title: translation(translationCache, 'Equipment Description'),
                dataIndex: 'Name',
                key: 'Name',
                ...getColumnSearchProps('Name')
              }
            ]}
            handleDropdownChange={(e) => TableDropdownChange(e, 'visible')}
          />
          {/* <HierarchyModal
              value={deviceId}
              treeData={treeData}
              translationCache={props.translationCache}
              language={props.language}
              handleDropdownChange={hierarchyDropdownChange}
              deviceList={deviceList}
            /> */}
        </Modal>
      </StyledComponent>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    themeValue: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache
  };
};
export default connect(mapStateToProps)(TaskForm);
